import { DateTime } from "luxon";

export class DateUtils {
  static getStartOfCurrentMonth(): Date {
    return DateTime.now().startOf('month').toJSDate();
  }

  static getEndOfCurrentMonth(): Date {
    return DateTime.now().endOf('month').toJSDate();
  }

  static formatDateTime(date: Date): string {
    return DateTime.fromJSDate(date).toFormat('dd.MM.yyyy HH:mm');
  }

  static formatMonthYear(date: Date): string {
    return DateTime.fromJSDate(date).toFormat('MMM yyyy');
  }

}